import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';

class TagsService extends ServiceCRUD {
  constructor() {
    super('tags');
  }
}

export default new TagsService();
